<div class="slideshow-container">
    <div class="slider-content">  
      <div class="slide-show-template fade" *ngFor="let i of photos;let y = index">
        <figure>
          <img [src]="i.imagem" [alt]="i.alt" style="width:100%" width="100%" />
        </figure>   
      </div>
    </div>
    <div class="dots" style="text-align:center">  
      <span class="dot" *ngFor="let i of photos;let y=index;" (click)="currentSlide((y+1))"></span>
    </div>
    <div class="swiper-button-prev sw-btn bg-2" (click)="plusSlides(-1)">
      <i class="fa-solid fa-angle-left"></i>
      <div class="overlay"></div>
    </div>
    <div class="swiper-button-next sw-btn bg-2" (click)="plusSlides(1)">  
      <i class="fa-solid fa-chevron-right"></i>
      <div class='overlay'></div>
    </div>  
</div> 